import { GroupsEnum } from "@/enum/groups";
import { RoleEnum } from "@/enum/role";
import PayrollVoucherApproval from "@/pages/conciliation/payroll-voucher-approval";
import { Receipt } from "lucide-react";
import { createRoute } from "../createRoute";
import { PATH_IDS } from "../path-ids";

const CATEGORIES = {
  RECURSOS_HUMANOS: "Recursos Humanos",
};

export const rhRoutes = [
  createRoute({
    id: "Aprovação de Vales",
    category: CATEGORIES.RECURSOS_HUMANOS,
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.RECURSOS_HUMANOS],
    path: "/aprovacao-de-vales/*",
    pathId: PATH_IDS.RECURSOS_HUMANOS,
    element: <PayrollVoucherApproval />,
    Icon: Receipt,
  }),
];
